var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('iframe',{staticStyle:{"border":"0"},attrs:{"width":"100%","height":"1000px","src":_vm.isFranchiseOrHigher
        ? 'https://lookerstudio.google.com/embed/reporting/a215da2b-0926-4597-a100-46e7b4e299f0/page/p_6yaj5ywu3c'
        : 'https://lookerstudio.google.com/embed/reporting/4183b930-cfbb-4ac3-9cb8-fb71815dff51/page/p_6yaj5ywu3c',"frameborder":"0","allowfullscreen":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }